import { Box, Typography } from "@mui/material";
import section_example from "@/assets/images/section_example.png";
import Image from "next/image";

export function SectionsDefinition() {
	return (
		<>
			<Typography variant='body2'>
				Seções são entidades que agrupam perguntas por tema. Uma seção,
				portanto, compõe uma ou mais perguntas diferentes.
			</Typography>
			<Typography variant='body2'>
				Uma seção não possui necessariamente uma relação direta com as perguntas
				que agrupas, mas contempla e informa ao usuário sobre qual o tema que
				tais perguntas abordam.
			</Typography>

			<Box>
				<Image
					loading='lazy'
					height={200}
					placeholder='blur'
					src={section_example}
					alt='exemplo de visualização de seção'
					style={{ borderRadius: "0.25rem" }}
				/>
				<Typography component={"p"} variant='caption' sx={{ paddingLeft: 0.5 }}>
					Exemplo de visualização de seção sem perguntas
				</Typography>
			</Box>

			<Typography variant='body2'>
				As seções podem ser compostas por perguntas de todos os tipos (múltipla
				escolha, escolha única e aberta).
			</Typography>

			<Typography variant='body2'>
				Por questões temáticas, é possível que uma seção apareça em mais de um
				questionário AIA e EPS com perguntas diferentes.
			</Typography>
		</>
	);
}
